
import React from "react"
import PropTypes from "prop-types"
import { Modal } from "antd"
import Form from "./Form"

function FormAntdModal({visible,setVisible,expenseId,expense,record,...props}) {
  const handleClose = () => {
    setVisible(false)
    if (props.onClose) props.onClose()
  }


  return (
    <Modal
      open={visible}
      onCancel={handleClose}
      footer={null}
      width={800}
      destroyOnClose
      centered
    >
      <Form {...props} closeHandler={handleClose} expenseId={expenseId} expense={expense} setVisible={setVisible} />
    </Modal>
  )
}

FormAntdModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  expenseId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  expense: PropTypes.object,
  record: PropTypes.object,
  onClose: PropTypes.func,
}

export default FormAntdModal
